export default __webpack_public_path__ + "static/media/Info.51ae1fae.svg";